import React, { useEffect, useRef } from "react";

export function Fold({ open, children }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.inert = !open;
    }
  }, [open]);

  return (
    <div className={`md-fold${open ? " is-open" : ""}`}>
      <div className="md-fold-in" ref={ref}>
        {children}
      </div>
    </div>
  );
}
